import { ProductTile } from 'product';
import React from 'react';
import { useSelector } from 'react-redux';
import './ProductCarousel.scss';
function ProductCarousel({ title, products }) {
    const isSubscriptionMode = useSelector((state) => state.subscription.isSubscriptionMode);
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, title),
        React.createElement("div", { className: "scroll" }, products.map((product, i) => {
            return (React.createElement("div", { className: "scroll-item", key: product.id },
                React.createElement(ProductTile, { product: product, variant: `variant-${(i % 5) + 1}`, shrinkOnMobile: false, isSubscriptionMode: isSubscriptionMode })));
        }))));
}
export default ProductCarousel;
